import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const PAGE_SIZE = 10;

export default function Pagination({ page, total, pageSize = PAGE_SIZE, onPage }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between px-1 py-2 text-sm" data-testid="pagination">
      <span className="text-slate-500">{from}–{to} sur {total}</span>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" data-testid="page-prev" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          <ChevronLeft size={16} /> Précédent
        </Button>
        <span className="text-slate-600 font-medium px-2">Page {page} / {pages}</span>
        <Button variant="outline" size="sm" data-testid="page-next" disabled={page >= pages} onClick={() => onPage(page + 1)}>
          Suivant <ChevronRight size={16} />
        </Button>
      </div>
    </div>
  );
}
